import React from 'react';
import {
  Grid,
  Typography,
  Paper,
  TextField,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';

const TestBlastCampaign = ({
  formData,
  testData,
  onTestDataChange,
  onTestCampaign,
  templates,
}) => {
  const handleTestDataChange = (field, value) => {
    onTestDataChange({
      ...testData,
      [field]: value
    });
  };

  const handleTestCampaign = () => {
    // Get the channel config
    const channelConfig = formData[`${formData.channel}_config`];
    
    // Check if the channel config has a from_endpoint_value configured
    if (!channelConfig?.from_endpoint_value) {
      onTestDataChange({
        ...testData,
        testStatus: 'error',
        testError: 'Please configure the "From" endpoint in the Message Configuration step before testing.'
      });
      return;
    }

    onTestCampaign();
  };

  const isTestDisabled = () => {
    if (testData.testStatus === 'loading') return true;
    if (formData.channel === 'email' && !testData.email) return true;
    if ((formData.channel === 'sms' || formData.channel === 'voice') && !testData.phone) return true;

    // Check if the channel config has a from_endpoint_value configured
    const channelConfig = formData[`${formData.channel}_config`];
    if (!channelConfig?.from_endpoint_value) return true;

    return false;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Test Your Campaign
        </Typography>
        <Paper sx={{ p: 3 }}>
          {formData.channel === 'email' && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Send a test email to verify your campaign setup
                </Typography>
                <TextField
                  fullWidth
                  type="email"
                  label="Test Email Address"
                  value={testData.email || ''}
                  onChange={(e) => handleTestDataChange('email', e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          )}

          {(formData.channel === 'sms' || formData.channel === 'voice') && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Send a test {formData.channel === 'sms' ? 'SMS' : 'voice call'} to verify your campaign setup
                </Typography>
                <TextField
                  fullWidth
                  type="tel"
                  label="Test Phone Number"
                  value={testData.phone || ''}
                  onChange={(e) => handleTestDataChange('phone', e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          )}

          {formData.channel === 'chat' && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Alert severity="info">
                  Chat-based campaign testing is coming soon!
                </Alert>
              </Grid>
            </Grid>
          )}

          {formData.channel !== 'chat' && (
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={handleTestCampaign}
                disabled={isTestDisabled()}
              >
                {testData.testStatus === 'loading' ? (
                  <CircularProgress size={24} />
                ) : (
                  'Send Test'
                )}
              </Button>
              {!formData[`${formData.channel}_config`]?.from_endpoint_value && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                  Please configure the "From" endpoint in the Message Configuration step before testing.
                </Alert>
              )}
            </Grid>
          )}

          {testData.testStatus === 'success' && (
            <Alert severity="success" sx={{ mt: 2 }}>
              Test message sent successfully!
            </Alert>
          )}

          {testData.testStatus === 'error' && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {testData.testError}
            </Alert>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TestBlastCampaign; 